import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useSearchMgr} from 'coreHooks';
import {useCategory, useSubCategories} from 'coreHooks/categories';

import {DEFAULT_SEARCH_PARAMS, FIRST_PAGE} from 'brand/app/constants';
import Button from 'brandComponents/Button';

import messages from './messages';

import styles from './ProductSearchCategories.module.scss';

const ProductSearchCategories = () => {//TODO: verify if still works
	const {getInstance} = useSearchMgr();
	const searchMgr = getInstance();
	const searchModel = searchMgr.getStoredSearchModel();
	const intl = useIntl();
	const [categories, setCategories] = useState([]);
	const currentRefinements = searchMgr.getUserSelectedRefinements();
	const searchQuery = searchMgr.getSearchQuery() || '';
	const [queryState, setQueryState] = useState('');
	const cgidRefinementModel = searchModel.getRefinement('cgid', true);
	const rootCategory = useCategory('root');
	const subCategories = useSubCategories(rootCategory);

	const filterByCategory = (categoryId: string) => {
		if (cgidRefinementModel) {
			const cgidRefinementValue = cgidRefinementModel?.getRefinementValueModelByValue(categoryId, true);

			if (cgidRefinementValue) {
				cgidRefinementValue.toggle();
			}

			searchMgr.clearRefinements();
			searchMgr.search();
		}
	};

	useEffect(() => {
		if (currentRefinements || queryState !== searchQuery) {
			const tabCategories = [];
			const promises = [];

			setQueryState(searchQuery);

			subCategories.filter(firstLevelCat => firstLevelCat.isShowInSearchTabs())
				.map((category) => {
					const categorySearchMgr = getInstance(category?.getId());

					subCategories[category?.getId()] = category;
					promises.push(categorySearchMgr.search({
						refinements: {cgid: [category?.getId()]},
						searchQuery: searchMgr.getSearchQuery(),
						page: FIRST_PAGE,
						limitParam: DEFAULT_SEARCH_PARAMS.limit
					}));
				});

			Promise.all(promises).then((results) => {
				results.map((res) => {
					if (res?.getTotalLoadedProductsNumber() > 0) {
						const refinements = res.getSelectedRefinements();

						if (refinements && refinements.cgid && subCategories[refinements.cgid]) {
							tabCategories.push(subCategories[refinements.cgid]);
						}
					}
				});

				setCategories(tabCategories);
			});
		}
	}, [currentRefinements, searchQuery]);

	return (<div className={styles['product-search-categories']}>
		<Button
			classNames={cn(styles['product-search-categories_category'],
				cgidRefinementModel?.getActiveValuesCount() === 0
				&& styles['product-search-categories_category-active']
			)}
			key={'all'}
			onClick={(e) => {
				e.preventDefault();
				filterByCategory('');
			}}
		>
			{intl.formatMessage(messages.all)}
		</Button>
		{categories?.map((category) => {
			const cgidRefinementValueModel = cgidRefinementModel?.getRefinementValueModelByValue(category?.getId());

			return (
				<Button
					classNames={cn(styles['product-search-categories_category'],
						cgidRefinementValueModel?.isActive()
						&& styles['product-search-categories_category-active'])}
					key={category?.getId()}
					onClick={(e) => {
						e.preventDefault();
						filterByCategory(category?.getId());
					}}
				>
					{category?.getName()}
				</Button>
			);
		})}
	</div>);
};

export default ProductSearchCategories;
